import React, { useState, useEffect, useContext } from "react";
import {
  IconButton,
  Badge,
  Menu,
  MenuItem,
  Typography,
  Box,
  Card,
  CardContent,
  Grid,
  Button,
} from "@mui/material";
import Notifications from "@mui/icons-material/Notifications";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import CloseIcon from "@mui/icons-material/Close";
import colors from "../../../config/colors";
import * as ApiService from "../../../api";
import { useSelector } from "react-redux";
import { convertDateFormat } from "../../utils/helpers";
import { ConfigurationContext } from "../../context/configurationContext";
import { useNavigate } from "react-router-dom";

const NotificationBar = () => {
  const [notifications, setNotifications] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedNotificationId, setSelectedNotificationId] = useState(null);
  const open = Boolean(anchorEl);
  const infoAfiliado = useSelector((state) => state.afiliado.infoAfiliado);
  const { setNumeroCasoNotificacion } = useContext(ConfigurationContext)

   var navigate = useNavigate();

  useEffect(() => {
    postNotification();
  }, []);

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const markAsRead = (id) => {
    setNotifications((prev) =>
      prev.map((notif) =>
        notif.codigo === id ? { ...notif, read: true } : notif
      )
    );
  };

  const handleNotificationClick = (id) => {
    markAsRead(id);
    setSelectedNotificationId((prev) => (prev === id ? null : id));
  };

  const unreadCount = notifications.filter((notif) => !notif.read).length;

  const postNotification = async () => {
    //setNotifications
    await ApiService.notificaciones
      .postConsNotificacion(infoAfiliado.codigoAfiliado)
      .then((response) => {
        setNotifications(response.data.result);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleVerDetalle = (notificacion) => {
    if (notificacion.enlace.includes("senasaafiliadosapp://Servicio/Historial/")){
      const caso = notificacion.enlace.split("senasaafiliadosapp://Servicio/Historial/")[1]
      setNumeroCasoNotificacion(caso)
      handleCloseMenu()
      handleNotificationClick(notificacion.id)
      navigate("/solicitudes");
    }

  }

  return (
    <>
      <IconButton
        color="inherit"
        onClick={handleOpenMenu}
        sx={{
          fontSize: "2rem",
          color: colors.primary,
          padding: 1,
          "&:hover": {
            backgroundColor: "rgba(25, 118, 210, 0.1)",
          },
        }}
      >
        <Badge
          badgeContent={unreadCount}
          color="error"
          sx={{
            "& .MuiBadge-badge": {
              fontSize: "0.9rem",
              height: "22px",
              minWidth: "22px",
            },
          }}
        >
          <Notifications
            sx={{
              fontSize: "2.5rem",
              color: colors.primary,
              display: "block",
            }}
          />
        </Badge>
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        sx={{
          "& .MuiPaper-root": {
            borderRadius: "10px",
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
            minWidth: "300px",
          },
        }}
      >
        {notifications.length > 0 ? (
          notifications.map((notif) => (
            <Box
              key={notif.codigo}
              sx={{
                marginBottom:
                  selectedNotificationId === notif.codigo ? "15px" : "0",
              }}
            >
              <Box
                onClick={() => handleNotificationClick(notif.codigo)}
                sx={{
                  margin: "10px 15px",
                  borderRadius: "8px",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                  overflow: "hidden",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  transition: "box-shadow 0.3s ease, transform 0.3s ease",
                  "&:hover": {
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                    transform: "scale(1.02)",
                  },
                }}
              >
                <Card sx={{ flex: 1 }}>
                  <Grid
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <Grid>
                      <CardContent>
                        <Typography
                          variant="subtitle1"
                          color={notif.read ? "textSecondary" : "textPrimary"}
                          sx={{
                            fontWeight: notif.read ? "400" : "600",
                            color: colors.primary,
                          }}
                        >
                          {notif.origen}
                        </Typography>
                        <Typography
                          variant="body2"
                          color="textSecondary"
                          sx={{ marginTop: "4px", fontWeight: "bold" }}
                        >
                          {notif.description}
                        </Typography>
                        <Typography
                          variant="caption"
                          color="textSecondary"
                          sx={{
                            marginTop: "4px",
                            display: "block",
                            fontWeight: "bold",
                          }}
                        >
                          {convertDateFormat(notif.fecha)}
                        </Typography>
                      </CardContent>
                    </Grid>
                    <Grid>
                      {selectedNotificationId === notif.codigo ? (
                        <CloseIcon sx={{ color: colors.error }} />
                      ) : (
                        <ArrowForwardIosIcon sx={{ color: colors.primary }} />
                      )}
                    </Grid>
                  </Grid>
                </Card>
              </Box>
              {selectedNotificationId === notif.codigo && (
                <Box
                  sx={{
                    margin: "10px 15px",
                    borderRadius: "8px",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                    padding: "10px",
                    backgroundColor: "#f9f9f9",
                    transition: "all 0.3s ease",
                    maxWidth: "300px",
                  }}
                >
                  <Typography
                    variant="subtitle1"
                    color={notif.read ? "textSecondary" : "textPrimary"}
                    sx={{
                      fontWeight: notif.read ? "400" : "600",
                      color: colors.primary,
                    }}
                  >
                    Código
                  </Typography>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    sx={{ fontWeight: notif.read ? "400" : "600" }}
                  >
                    {notif.codigo}
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    color={notif.read ? "textSecondary" : "textPrimary"}
                    sx={{
                      fontWeight: notif.read ? "400" : "600",
                      color: colors.primary,
                      marginTop: "10px",
                    }}
                  >
                    Detalle
                  </Typography>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    sx={{ marginTop: "4px", fontWeight: "bold" }}
                  >
                    {notif.detalle}
                  </Typography>
                  {notif.enlace &&                   <Button
            id="btn-verdetalle"
            fullWidth
            variant="contained"
            style={{  
              backgroundColor: colors.primary, 
              width: 200, 
              textTransform: 'initial',
              marginInline: 50,
            marginTop: 10 }}
            onClick={() => handleVerDetalle(notif)}
          >
            Ver detalle
          </Button>}

                </Box>
              )}
            </Box>
          ))
        ) : (
          <MenuItem>
            <Typography variant="body2" color="textSecondary">
              No tienes notificaciones
            </Typography>
          </MenuItem>
        )}
      </Menu>
    </>
  );
};

export default NotificationBar;
